/**
* Copyright (c) 2025 Bytedance, Inc. and its affiliates.
* SPDX-License-Identifier: Apache-2.0
*/
function extractPageInformation(window, readabilityScript) {
    const Readability = new Function('module', `${readabilityScript}\nreturn module.exports`)({});
    const document = window.document;
    document.querySelectorAll("script,noscript,style,link,svg,img,video,iframe,canvas,.reflist").forEach((el)=>el.remove());
    const article = new Readability(document).parse();
    const content = (null == article ? void 0 : article.content) || '';
    const title = document.title;
    return {
        content,
        title: (null == article ? void 0 : article.title) || title
    };
}
export { extractPageInformation };

//# sourceMappingURL=extract-page-info.mjs.map